export const constants =  {
    NETE: 'NETE',
    NETEBLUE: 'NETE_BLUEOCEAN',
    NETENETE: 'NETE_NETE',
    NLCNLC: 'NLC_NLC',
    PNG: 'PNG',
    ORYX: 'ORYX',
    IGT: 'IGT',
    SLINGO: 'SLINGO',
    F1X2: 'F1X2',
    PRAGMATIC_PLAY: 'PRAGMATIC_PLAY',
    GREENTUBE: 'GREENTUBE',
    RELAX: 'RELAX',
    PUSH: 'PUSH',
    SW: 'SW',
    BTG: 'BTG',
    GVY: 'GVY',
    SBLT: 'SBLT',
    AMATIC: 'AMATIC',
    EVOLUTION: 'EVOLUTION',
    EXCITE: 'EXCITE',
    EVOL: 'EVOL',
    ORYX_WS: 'ORYX_WS',
    LOTTOLAND: 'LOTTOLAND',
    GIG: 'GIG',
    SBTECH: 'SBTECH',
    GAM: 'GAM',
    GIVME: 'GIVME',
    KLM: 'KLM',
    GHG: 'GHG',
    PP: 'PP',
    SLG: 'SLG',
    GTB: 'GTB',
    REAL: 'REAL',
    MGS: 'MGS',
    EGT: 'EGT',
    BP: 'BP',
    THUNDER: 'THUNDER',
    NEXTGEN: 'NEXTGEN',
    NLC: 'NLC',
    EDICT: 'EDICT',
    NSOFT: 'NSOFT',
    EZUGI: 'EZUGI',
    LOGOUT: 'logout',
    // GSBINGO: 'GSYSB',
    GSPOKER: 'GSYSP',
    BGS: 'BGS',
    RGU: 'RGU',
    RAW: 'RAW',
    HB: 'HB',
    DGC: 'DGC',
    STAKELOGIC: 'STK',
    STAKELOGIC2: 'STK2',
    QS: 'QS',
    SH: 'SH',
    RRG: 'RRG',
    FAZI: 'FAZI',
    GAMEIOM: 'GAMEIOM',
    ORYX2: 'ORYX2',
    ASL: "ASL",
    CDB: "CDB",
    PSO: "PSO",
    ARC: "ARC",
    O2X: "O2X",
    EVP: 'EVP',
    WD: 'WD',
    WZD: 'WZD',
    SPINGAMES: 'SPINGAMES',
    BWIN: 'BWIN',
    RSI: 'RSI',
    DKG: 'DKG',
    PLAYTECH: 'PLAYTECH',
    SPRIBE: 'SPRIBE',
    HI5: 'HI5',
    HKS: 'HKS',
    SYN: 'SYN',
    KAJ: 'KAJ',
    DUSO: 'DUSO',
    BLG: 'BLG',
    GMT: 'GMT',
    BBR: 'BBR',
    ISOFT: 'ISOFT',
    RST: 'RST',
    NYXNEXTGEN: 'NYX_NEXTGEN',
    NYXSG: 'NYX_SG',
    NYXBDG: 'NYX_BDG',
    NYXBTG: 'NYX_BTG',
    NYXTHUNDER: 'NYX_THUNDER',
    BETCONSTRUCT: 'BETCONSTRUCT',
    SWT: 'SWT',
    PT: 'PT',
    YGG: 'YGG',
    ZITRO: 'ZITRO',
    FBM: 'FBM',
    HBN: 'HBN',
    GAN: 'GAN',
    SGD: 'SGD',
    PALA: 'PALA',
    YAT: 'YAT',
    SPIN: 'SPIN',
    BFG: 'BFG',
    COMEON: 'COMEON',
    POKERSTARS: 'POKERSTARS',
    LNWOGS: 'LNWOGS',
    AMELCO: 'AMELCO',
    ENDOR: 'ENDOR',
    PLS: 'PLS',
    SPIN2PLAYTECH: 'SPIN2PLAYTECH',
    EVOLNETE: 'EVOL_NETE',
    EVOLRTG: 'EVOL_RTG',
    EVOLNLC: 'EVOL_NLC',
    EVOLBTG: 'EVOL_BTG',
    EVOLEZUGI: 'EVOL_EZUGI',
    EVOLEVOL: 'EVOL_EVOL',
    KIRON: 'KRN',
    GDR2: 'GDR2',
    GDR2HTV: 'HTV',
    GDR2SMT: 'SMT',
    APL: 'APL',
    BETGAMESTV: 'BGT',
    IT: 'IT',
    EBC: 'EBC',
    GLX: 'GLX',
    FSLV: 'FSLV',
    GLAB: 'GLAB',
    GVG: 'GVG',
    WS2: 'WS2',
    EI: 'EI',
    SPINOMENAL: 'SPN',
    BGM: 'BGM',
    CAESARSCASINONJ: 'CAESARSCASINONJ',
    CAESARSCASINOPA: 'CAESARSCASINOPA',
    CAESARSMI: 'CAESARSMI',
    CAESARSNJ: 'CAESARSNJ',
    CAESARSON: 'CAESARSON',
    CAESARSPA: 'CAESARSPA',
    CAESARSWV: 'CAESARSWV',
    CAESARS: 'CAESARS',
    STT: 'STT',
    SSG: 'SSG',
    EDIG: 'EDIG',
    T4B: 'T4B',
    EYE: 'EYE',
    HNR: 'HNR',
    OAK: 'OAK',
    INTRALOT: 'INTRALOT',
    BSFT: "BSFT",
}